import { post } from '../../../services/RestTemplate';

const authUrl = '/auth/';

export const forgotPassword = emailAddress => {
    return post(authUrl + 'forgotpassword', { emailAddress });
};
